import { createFileRoute } from "@tanstack/react-router";
import { ArticleEditor } from "./admin.new";

export const Route = createFileRoute("/admin/edit/$id")({
  component: EditPage,
});

function EditPage() {
  const { id } = Route.useParams();
  return <ArticleEditor id={id} />;
}
